import * as roles from '../../../constants/system-roles';

export const getRoleAdjustedUrl = (url, roleId) =>
  roleId === roles.VIP_PARTNER ? url.replace('/data-reports', '') : url;
